module.exports = __webpack_public_path__ + "img/symbol-roman-tl-left.cf280589.png";